import AwsResponse from "types/awsResponse"
import { StatePayer } from "./useInsurancePayers.d"

export const fetchInsurancePayersByState = async ( state : string ) : Promise<AwsResponse<StatePayer[]>> => {

  const response = await fetch( `${process.env.REACT_APP_LAMBDA_PAYERS_URL}/form/sleep_qualify_through_insurance/${state.length ? state : `NC`}` )

  return await response.json()
}